// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".settingContainer--1vJI0RLX {\n  width: 260px;\n}\n\n.headerContainer--SUXmWIki {\n  display: grid;\n  height: 42px;\n  align-items: center;\n  padding: 0 0 0 14px;\n  border-bottom: 1px solid var(--theme-gray-border-color);\n}\n\n.settingItem--17FYwzIg {\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: space-between;\n  padding: 12px;\n  align-items: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingContainer": "settingContainer--1vJI0RLX",
	"headerContainer": "headerContainer--SUXmWIki",
	"settingItem": "settingItem--17FYwzIg"
};
export default ___CSS_LOADER_EXPORT___;
